import { Link } from "react-router-dom";

export default function SubmitCta() {
  return (
    <section className="bg-primary-600">
      <div className="mx-auto flex w-full max-w-content flex-col gap-8 px-4 py-14 md:flex-row md:items-center md:justify-between md:px-8 md:py-16">
        <div className="max-w-2xl">
          <p className="mb-3 flex items-center gap-2 text-xs tracking-[0.2em] text-primary-100">
            <i className="ri-megaphone-line text-base" aria-hidden="true" />
            线索征集
          </p>
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            你踩过的坑，可能正是别人要避的雷
          </h2>
          <p className="mt-4 text-sm leading-7 text-primary-50">
            把你经历过的套路、看到过的异常分享出来。请隐去无关个人的姓名与联系方式，我们只关心手法本身，核对后会以案例形式整理发布。
          </p>
        </div>
        <Link
          to="/about#submit"
          className="inline-flex w-fit items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400"
        >
          <i className="ri-send-plane-line text-base" aria-hidden="true" />
          提交线索
        </Link>
      </div>
    </section>
  );
}